document.addEventListener("DOMContentLoaded", function () {
    // Get all accordion buttons
    const accordionButtons = document.querySelectorAll(".accordion-button");

    accordionButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const targetId = this.getAttribute("data-bs-target");
            const targetElement = document.querySelector(targetId);

            // Toggle 'show' class on the clicked item
            if (targetElement.classList.contains("show")) {
                targetElement.classList.remove("show");
                this.setAttribute("aria-expanded", "false");
            } else {
                // Show the clicked item
                targetElement.classList.add("show");
                this.setAttribute("aria-expanded", "true");
            }
        });
    });
});
